import React from 'react';
import PropTypes from 'prop-types';
import { Col as StyledCol } from 'styled-bootstrap-grid';

const Col = ({
  children, col, className,
  xs, sm, md, lg, xl, xxl,
}) => (
  <StyledCol
    col={col}
    className={className}
    xs={xs}
    sm={sm}
    md={md}
    lg={lg}
    xl={xl}
    xxl={xxl}
  >
    {children}
  </StyledCol>
);

Col.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  col: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  xs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  md: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  xl: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  xxl: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Col.defaultProps = {
  children: null,
  className: null,
  col: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  xxl: null,
};

export default Col;
